import React from "react";
import { Tag } from "antd";
import { getStatusConfig } from "../status/statusConfig";

const JobStatusBadge = ({ status }) => {
  const config = getStatusConfig(status);

  return (
    <Tag color={config.color} icon={config.icon}>
      {config.label}
    </Tag>
  );
};

export default JobStatusBadge;
